import TextField from "./TextField";
import PasswordField from "./PasswordField";
import NumberField from "./NumberField";
import TextArea from "./TextArea";
import Combobox from "./Combobox/ComboboxWrapper";
import Toggle from "./Toggle";
import Slider from "./Slider";
import Radio from "./Radio";
import Search from "./Search";
import DatePicker from "./DatePicker";
import Checkbox from "./CheckBox";
import QueryBuilder from "./QueryBuilder";
import MassiveMultiSelect from "./MassiveMultiSelect";

export const CONTROLS = {
  text: TextField,
  email: TextField,
  password: PasswordField,
  number: NumberField,
  textarea: TextArea,
  combobox: Combobox,
  toggle: Toggle,
  checkbox: Checkbox,
  slider: Slider,
  radio: Radio,
  date: DatePicker,
  search: Search,
  query: QueryBuilder,
  mms: MassiveMultiSelect,
};

export const DATETYPES = ["date", "month", "year", "quarter"];
